import styled from 'styled-components';
import HelperText from 'components/HelperText';
import { Stack } from 'components/Stack';
import { mediaBreakpointDown } from '../../../../../../styles/grid';

const modalMobileBreakpoint = mediaBreakpointDown.sm;

export const Container = styled(Stack)<{ isMobile: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '16px 10px' : '16px')};
`;

export const BodyContainer = styled(Stack)``;

export const CTAButtonsContainer = styled(Stack)`
  margin-top: 16px;
  display: flex;
  ${modalMobileBreakpoint} {
    flex-direction: column;
  }
`;

export const ConfirmMessage = styled.div`
  text-align: left;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;

export const ErrorMessage = styled(HelperText).attrs({
  isError: true,
})`
  display: block;
  margin-top: 8px;
`;
